import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Role-based routing:
 * - admin: Can access everything
 * - comercial: Portal Comercial only
 * - tecnico: Portal Técnico only  
 * - cliente/user: Portal Cliente only
 */

export function ProtectedRoute({ children, allowedRoles = [], adminOnly = false }) {
  const { user, loading, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#050505' }}>
        <div className="w-8 h-8 border-2 border-white/20 border-t-white rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Admin has access to everything
  if (isAdmin) {
    return children;
  }

  // Legacy adminOnly support
  if (adminOnly && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  // Role-based access
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    // Redirect to appropriate portal based on role
    const roleRedirects = {
      'comercial': '/comercial',
      'tecnico': '/tecnico',
      'cliente': '/dashboard',
      'user': '/dashboard'
    };
    return <Navigate to={roleRedirects[user.role] || '/dashboard'} replace />;
  }

  return children;
}

export function PublicRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#050505' }}>
        <div className="w-8 h-8 border-2 border-white/20 border-t-white rounded-full animate-spin" />
      </div>
    );
  }

  if (user) {
    // Role-based redirect after login
    const roleRedirects = {
      'admin': '/admin',
      'comercial': '/comercial',
      'tecnico': '/tecnico',
      'cliente': '/dashboard',
      'user': '/dashboard'
    };
    return <Navigate to={roleRedirects[user.role] || '/dashboard'} replace />;
  }

  return children;
}
